var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 51,
    viewBox: "0 0 38 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 51,
    fill: "#B8B8B8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1057,
    transform: "translate(-1085 -528)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: -1085,
    y: -528,
    width: 1920,
    height: 1057,
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -432,
    y: -295,
    width: 863,
    height: 589,
    rx: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61475 0H23.6024L38 15.007V44.1959C38 47.8524 35.0418 50.8106 31.3979 50.8106H6.61475C2.95823 50.8106 1.04491e-09 47.8524 1.04491e-09 44.1959V6.61475C-6.4198e-05 2.95823 2.95816 0 6.61475 0Z",
    fill: "#E5252A",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5898 0V14.8928H38.0002L23.5898 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35132 37.9111V28.6301H11.2999C12.2775 28.6301 13.052 28.8967 13.636 29.4427C14.22 29.9759 14.5121 30.6996 14.5121 31.6011C14.5121 32.5025 14.22 33.2262 13.636 33.7594C13.052 34.3054 12.2775 34.572 11.2999 34.572H9.72553V37.9111H7.35132ZM9.72553 32.5533H11.0333C11.3887 32.5533 11.6681 32.4771 11.8585 32.2994C12.049 32.1344 12.1506 31.9058 12.1506 31.6011C12.1506 31.2964 12.049 31.0679 11.8585 30.9028C11.6681 30.7251 11.3888 30.6489 11.0333 30.6489H9.72553V32.5533ZM15.4896 37.9111V28.6301H18.778C19.4255 28.6301 20.0349 28.719 20.6062 28.9095C21.1775 29.0999 21.6981 29.3666 22.1552 29.7347C22.6123 30.0902 22.9805 30.5727 23.2471 31.1821C23.501 31.7915 23.6407 32.4898 23.6407 33.277C23.6407 34.0515 23.501 34.7498 23.2471 35.3591C22.9805 35.9686 22.6123 36.451 22.1552 36.8065C21.6981 37.1747 21.1775 37.4413 20.6062 37.6318C20.0349 37.8222 19.4255 37.9111 18.778 37.9111H15.4896ZM17.8131 35.8925H18.4987C18.8668 35.8925 19.2097 35.8544 19.5271 35.7655C19.8317 35.6766 20.1238 35.5369 20.4031 35.3465C20.6697 35.1561 20.8856 34.8894 21.0379 34.5339C21.1903 34.1785 21.2665 33.7594 21.2665 33.277C21.2665 32.7818 21.1903 32.3629 21.0379 32.0074C20.8856 31.6519 20.6697 31.3853 20.4031 31.1948C20.1238 31.0044 19.8318 30.8647 19.5271 30.7759C19.2097 30.687 18.8668 30.6489 18.4987 30.6489H17.8131V35.8925ZM24.8341 37.9111V28.6301H31.4362V30.6489H27.2083V32.1343H30.5855V34.1403H27.2083V37.9111H24.8341Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1057,
    fill: "white",
    transform: "translate(-1085 -528)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfImg);
export default __webpack_public_path__ + "static/media/PDF_img.6cfcefef2d8c7fd9f4e9486f2639ad13.svg";
export { ForwardRef as ReactComponent };